import { setAttributes, findGetParameter } from '../helpers/productStyles';

export default class QuickAdd {
  constructor(productEl) {
    this.el = productEl;
    this.countOtherOptions = 2;
  }

  buildQuickAdd = (product) => {
    let formWrapButton = this.el.querySelector(
      '.product-card__quick-add--button button',
    );
    if (formWrapButton) {
      formWrapButton.removeAttribute('data-selected-variant');
      formWrapButton.removeAttribute('data-drawer-trigger');
      formWrapButton.textContent = 'Add to Cart';
    }
    product.optionsWithValues.forEach((option) => {
      let optionLower = option.name.toLowerCase();
      if (optionLower != 'color') {
        let otherListNode = this.el.querySelector(
          `.product-card__swatches--items[data-${optionLower}-swatches]`,
        );
        if (otherListNode) {
          otherListNode.innerHTML = '';
          let displayedOptions = [];
          if (
            this.el.querySelector(
              `.product-card__option-heading-${optionLower}`,
            ) == null
          ) {
            let optionHeading = document.createElement('div');
            optionHeading.classList.add(
              `product-card__option-heading-${optionLower}`,
              `product-card__option-heading`,
            );
            optionHeading.textContent = `${option.name}:`;
            let optionHeadingParent = this.el.querySelector(
              '.product-card__quick-add',
            );
            optionHeadingParent.insertBefore(optionHeading, otherListNode);
          }
          option.values.forEach((value, index) => {
            let otherSwatch = document.createElement('div');
            otherSwatch.classList.add('variants__size--item');
            let variantAvailability;
            if (option.position == 2 && product.optionsWithValues.length > 2) {
              variantAvailability = false;
              product.optionsWithValues[option.position].values.forEach(
                (width) => {
                  if (variantAvailability == false) {
                    product.variants.forEach((widthVariant) => {
                      if (
                        widthVariant.options.includes(value) &&
                        widthVariant.options.includes(width) &&
                        widthVariant.available
                      ) {
                        variantAvailability = true;
                      }
                    });
                  }
                },
              );
            } else {
              variantAvailability = product.variants[index].available;
            }
            setAttributes(otherSwatch, {
              'data-variant-option-value': value,
              'data-variant-option-index': `option${option.position}`,
              'data-variant-available': variantAvailability,
            });
            if (
              optionLower != 'size' &&
              product.optionsWithValues.length > this.countOtherOptions &&
              !findGetParameter('variant')
            ) {
              otherSwatch.setAttribute('disabled', 'disabled');
            }
            let otherSwatchSpan = document.createElement('span');
            otherSwatchSpan.textContent = value;
            otherSwatch.appendChild(otherSwatchSpan);
            if (!displayedOptions.includes(value)) {
              otherListNode.appendChild(otherSwatch);
              otherSwatch.addEventListener('click', (e) => {
                if (e.currentTarget.classList.contains('selected')) {
                  return false;
                }
                let selectedSwatchNode = this.el.querySelector(
                  `.product-card__swatches--items[data-${optionLower}-swatches] .variants__size--item.selected`,
                );
                if (selectedSwatchNode) {
                  selectedSwatchNode.classList.remove('selected');
                }
                e.currentTarget.classList.add('selected');
                let choosedVariant;
                if (
                  optionLower == 'size' &&
                  product.optionsWithValues.length > this.countOtherOptions
                ) {
                  this.el
                    .querySelectorAll(
                      '.product-card__swatches--items[data-width-swatches] .variants__size--item',
                    )
                    .forEach((item) => {
                      item.removeAttribute('disabled');
                      let sizeValue = this.el.querySelector(
                        '.product-card__swatches--items[data-size-swatches] .variants__size--item.selected',
                      ).dataset.variantOptionValue;
                      let widthValue = item.dataset.variantOptionValue;
                      let clickedVariant = product.variants.filter(
                        (variant) => {
                          if (
                            variant.options.includes(sizeValue) &&
                            variant.options.includes(widthValue)
                          ) {
                            return variant;
                          }
                        },
                      );
                      item.dataset.variantAvailable =
                        clickedVariant[0].available;
                    });
                }
                if (
                  optionLower != 'size' ||
                  this.el.querySelector(
                    '.product-card__swatches--items[data-width-swatches] .variants__size--item.selected',
                  ) != null
                ) {
                  let selectedValues = [];
                  this.el
                    .querySelectorAll('.variants__size--item.selected')
                    .forEach((value) => {
                      selectedValues.push(value.textContent);
                    });
                  choosedVariant = product.variants.filter((variant) => {
                    if (
                      variant.options.includes(selectedValues[0]) &&
                      variant.options.includes(selectedValues[1])
                    ) {
                      return variant;
                    }
                  });
                }
                let setVariant = false;
                if (
                  optionLower == 'size' &&
                  product.optionsWithValues.length == 2
                ) {
                  choosedVariant = product.variants.filter((variant) => {
                    return variant.options.includes(value);
                  });
                  setVariant = true;
                } else if (
                  (choosedVariant && optionLower != 'size') ||
                  this.el.querySelector(
                    '.product-card__swatches--items[data-width-swatches] .variants__size--item.selected',
                  ) != null
                ) {
                  setVariant = true;
                }
                if (setVariant) {
                  if (choosedVariant[0].available) {
                    this.updatePrice(choosedVariant[0]);
                    this.updateCompareAtPrice(choosedVariant[0]);
                    let comparePriceAttribute = choosedVariant[0].compareAtPrice
                      ? choosedVariant[0].compareAtPrice
                      : '';
                    formWrapButton.textContent = 'Add to Cart';
                    formWrapButton.classList.remove('out-of-stock');
                    setAttributes(formWrapButton, {
                      'data-selected-variant': choosedVariant[0].id,
                      'data-drawer-trigger': '',
                      'data-compare-price-item': comparePriceAttribute,
                      'data-price-item': choosedVariant[0].price,
                    });
                  } else {
                    formWrapButton.removeAttribute('data-selected-variant');
                    formWrapButton.removeAttribute('data-drawer-trigger');
                    formWrapButton.textContent = 'Out of Stock';
                  }
                }
              });
              displayedOptions.push(value);
            }
          });
        }
      }
    });
  };

  updatePrice = (variant) => {
    this.el.querySelectorAll('[data-product-price]').forEach((priceItem) => {
      priceItem.textContent = variant.formattedPrice;
      if (
        !variant.formattedCompareAtPrice ||
        variant.formattedCompareAtPrice == variant.formattedPrice
      ) {
        priceItem.classList.remove('sale-price');
      } else if (variant.formattedCompareAtPrice != variant.formattedPrice) {
        priceItem.classList.add('sale-price');
      }
    });
  };

  updateCompareAtPrice = (variant) => {
    let comparePrice = variant.formattedCompareAtPrice
      ? variant.formattedCompareAtPrice
      : '';
    if (variant.formattedCompareAtPrice != variant.formattedPrice) {
      this.el
        .querySelectorAll('[data-product-compare]')
        .forEach((priceItem) => {
          priceItem.textContent = comparePrice;
        });
    } else {
      this.el
        .querySelectorAll('[data-product-compare]')
        .forEach((priceItem) => {
          priceItem.textContent = '';
        });
    }
  };
}
